import { z } from 'zod'

export const DocumentAttachmentsSectionSchema = z.object({
  id: z.string(),
  type: z.literal('document_attachments'),
  title: z.string(),
  field: z.string(),
  required: z.boolean().default(false),
})

export type DocumentAttachmentsSection = z.infer<
  typeof DocumentAttachmentsSectionSchema
>

export const documentAttachmentIdsSchema = z.array(z.string().min(1))

export function mergeDocumentAttachmentIds(
  previous: readonly string[],
  uploaded: readonly string[]
): string[] {
  return [...new Set([...previous, ...uploaded])]
}
